import { useMutation } from 'react-query'

import { useCurrentWorkspace } from './useCurrentWorkspace'
import { useWorkspaces } from './useWorkspaces'
import { WorkspaceClient } from 'api/clients/WorkspaceClient'
import { UserService } from 'api/clients/UserService'

export const useUpdateAutoReloadCredits = () => {
  const workspace = useCurrentWorkspace()
  const workspaces = useWorkspaces()

  return useMutation({
    mutationFn: async ({
      autoReloadCredits,
      autoReloadLimit,
    }: {
      autoReloadCredits: boolean
      autoReloadLimit: number | null
    }) => {
      if (!workspace) {
        throw new Error('No workspace found')
      }
      return WorkspaceClient.setAutoReloadCredits(workspace.id, autoReloadCredits, autoReloadLimit)
    },
    onMutate: async ({ autoReloadCredits, autoReloadLimit }) => {
      if (!workspace) return

      // Save the previous workspaces for rollback
      const previousWorkspaces = workspaces

      // Optimistically update the workspace
      const updatedWorkspaces = workspaces.map((w) =>
        w.id === workspace.id
          ? { ...w, auto_reload_credits: autoReloadCredits, auto_reload_limit: autoReloadLimit }
          : w,
      )
      UserService.setWorkspaces(updatedWorkspaces)

      // Return context for rollback
      return { previousWorkspaces }
    },
    onError: (_error, _variables, context) => {
      // Rollback on error
      if (context?.previousWorkspaces) {
        UserService.setWorkspaces(context.previousWorkspaces)
      }
    },
  })
}
